import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import AboutCompany from "../Components/productListcomponents/companyContent";
import BuildProHomeContent from "../Components/BuildProHomeContent";
import axiosInstance from "./axiosInstance";
import whatsappIcon from "../Components/Assets/Calling.png";
import phoneIcon from "../Components/Assets/EmailICon.png";
import { baseurl } from "../config/url";

const Buyerschoice = () => {
  const [slidercategories, setSliderCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchCategories = async () => {
    try {
      const { data: categoriesData } = await axiosInstance.get(
        `${baseurl}/api/category/get-all`
      );
      // Fetch subcategories for each category
      const categoriesWithSubcategories = await Promise.all(
        (categoriesData || []).map(async (category) => {
          try {
            const { data: subs } = await axiosInstance.get(
              `${baseurl}/api/subcategory/category/${category._id}`
            );
            return { ...category, subcategories: subs || [] };
          } catch {
            return { ...category, subcategories: [] };
          }
        })
      );
      setSliderCategories(categoriesWithSubcategories);
    } catch (error) {
      console.error("Error fetching categories and subcategories:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleImageClick = (subcategoryId, categoryname) => {
    navigate(`/products/${subcategoryId}`, { state: { categoryname } });
  };

  const slug = (s = "") =>
    s
      .toString()
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-");

  const scrollToCategory = (name) => {
    const id = `cat-${slug(name)}`;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="min-h-[80vh] bg-gradient-to-b from-sky-50 via-white to-sky-50">
      {/* Header */}
      <header className="pt-10 px-4 sm:px-6">
        <h1 className="text-center text-2xl sm:text-3xl font-extrabold tracking-tight text-sky-900">
          Explore Our Categories
        </h1>
        <p className="mt-2 text-center text-sky-700 text-sm">
          Swipe through subcategories and tap to view products.
        </p>
      </header>

      {/* Quick Nav Chips (mobile-first horizontal scroll) */}
      <div className="mt-5 px-3 sm:px-6">
        <div className="flex gap-2 overflow-x-auto no-scrollbar py-1 -mx-1 px-1">
          {loading
            ? Array.from({ length: 8 }).map((_, i) => (
                <span
                  key={i}
                  className="min-w-[110px] h-9 rounded-full bg-sky-100/70 animate-pulse"
                  aria-hidden="true"
                />
              ))
            : slidercategories.map((c) => (
                <button
                  key={c._id}
                  onClick={() => scrollToCategory(c.name)}
                  className="px-4 py-2 rounded-full text-sm font-semibold border border-sky-200 bg-white text-sky-800 hover:bg-sky-50 shadow-sm transition focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-sky-400"
                >
                  {c.name}
                </button>
              ))}
        </div>
      </div>

      <main className="py-10 px-3 sm:px-6 lg:px-8">
        {/* Skeleton while loading */}
        {loading && (
          <div className="space-y-10" aria-hidden="true">
            {Array.from({ length: 3 }).map((_, i) => (
              <section key={i} className="bg-white/60 rounded-2xl p-4 shadow-sm">
                <div className="h-5 w-48 bg-sky-100/80 rounded mb-4" />
                <div className="relative">
                  <div className="grid grid-flow-col auto-cols-[70%] xs:auto-cols-[55%] sm:auto-cols-[40%] md:auto-cols-[30%] gap-3 overflow-hidden">
                    {Array.from({ length: 6 }).map((__, j) => (
                      <div
                        key={j}
                        className="rounded-xl bg-sky-100/60 h-[220px] sm:h-[260px] animate-pulse"
                      />
                    ))}
                  </div>
                </div>
              </section>
            ))}
          </div>
        )}

        {/* Categories with subcategory carousels */}
        {!loading &&
          slidercategories.map((category, idx) => (
            <section
              key={category._id || idx}
              id={`cat-${slug(category.name)}`}
              className="mb-14"
            >
              <div className="flex items-center justify-between mb-3 px-1">
                <h2 className="text-xl sm:text-2xl font-extrabold text-sky-900">
                  {category.name}
                </h2>
                 
              </div>

              <div className="bg-white border border-sky-100 rounded-2xl shadow-sm p-3">
                <Swiper
                  modules={[Autoplay, Pagination]}
                  autoplay={{ delay: 3500, disableOnInteraction: false }}
                  loop={true}
                  spaceBetween={12}
                  pagination={{ clickable: true }}
                  centeredSlides={true}
                  breakpoints={{
                    0: { slidesPerView: 1.2, centeredSlides: true, spaceBetween: 12 },
                    480: { slidesPerView: 1.6, centeredSlides: true, spaceBetween: 14 },
                    640: { slidesPerView: 2.2, centeredSlides: false, spaceBetween: 16 },
                    768: { slidesPerView: 3, centeredSlides: false, spaceBetween: 18 },
                    1024: { slidesPerView: 4, centeredSlides: false, spaceBetween: 20 },
                  }}
                >
                  {(category.subcategories || []).map((subcategory) => (
                    <SwiperSlide key={subcategory._id}>
                      <button
                        onClick={() =>
                          handleImageClick(subcategory._id, subcategory.name)
                        }
                        className="group w-full text-left bg-white rounded-xl overflow-hidden shadow-sm border border-sky-100 hover:shadow-md transition focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-sky-400"
                        aria-label={`Open ${subcategory.name} products`}
                      >
                        {/* Image ratio box */}
                        <div className="relative w-full">
                          <div className="pb-[66%]" />
                          {subcategory.image ? (
                            <img
                              src={`${baseurl}${subcategory.image}`}
                              alt={subcategory.name}
                              className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.03]"
                              loading="lazy"
                              decoding="async"
                              width="360"
                              height="238"
                              sizes="(max-width:640px) 85vw, (max-width:1024px) 40vw, 360px"
                              onError={(e) => {
                                e.currentTarget.src =
                                  "data:image/svg+xml;charset=UTF-8," +
                                  encodeURIComponent(
                                    `<svg xmlns='http://www.w3.org/2000/svg' width='400' height='266'><rect width='100%' height='100%' fill='#e2e8f0'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' fill='#64748b' font-family='Arial' font-size='14'>Image unavailable</text></svg>`
                                  );
                              }}
                            />
                          ) : (
                            <div className="absolute inset-0 bg-sky-100/60 flex items-center justify-center text-sky-400 text-sm">
                              No image
                            </div>
                          )}
                          {/* Bottom overlay with name */}
                          <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent px-3 py-2">
                            <p className="text-white font-semibold text-sm drop-shadow">
                              {subcategory.name}
                            </p>
                          </div>
                        </div>

                        {/* Body */}
                        <div className="p-3">
                          <p className="text-xs text-slate-600 min-h-[32px] line-clamp-2">
                            {subcategory.description || "Tap to view products"}
                          </p>
                        </div>
                      </button>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </section>
          ))}

        {/* Content blocks */}
        <div className="mt-6">
          <BuildProHomeContent />
        </div>

        <div className="mt-12">
          <AboutCompany />
        </div>
      </main>

      {/* Floating Contact Buttons */}
      <div className="fixed bottom-5 right-5 flex flex-col items-center gap-3 z-50">
        <a
          href="https://wa.me/919967610135"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white/90 backdrop-blur px-2 py-2 rounded-full shadow-lg ring-1 ring-sky-100 hover:shadow-xl transition-transform hover:scale-105"
          aria-label="Chat on WhatsApp"
        >
          <img
            src={whatsappIcon}
            alt="WhatsApp"
            className="w-11 h-11 object-contain"
            loading="lazy"
            decoding="async"
            width="44"
            height="44"
          />
        </a>

        <a
          href="https://mail.google.com/mail/?view=cm&fs=1&to=ogcspvtlt@gmail.com&su=BuildPro%20Support&body=Hello%20OGCS%20Team%2C%20I%20need%20help%20with..."
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white/90 backdrop-blur px-2 py-2 rounded-full shadow-lg ring-1 ring-sky-100 hover:shadow-xl transition-transform hover:scale-105"
          aria-label="Email support"
        >
          <img
            src={phoneIcon}
            alt="Email"
            className="w-11 h-11 object-contain"
            loading="lazy"
            decoding="async"
            width="44"
            height="44"
          />
        </a>
      </div>

      {/* Styles */}
      <style>{`
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }

        /* Swiper pagination bullets - mobile friendly */
        .swiper-pagination-bullet {
          background: #0ea5e9; /* sky-500 */
          opacity: 0.35;
        }
        .swiper-pagination-bullet-active {
          opacity: 1;
          background: #0369a1; /* sky-700 */
        }
      `}</style>
    </div>
  );
};

export default Buyerschoice;
